import React, { CSSProperties, memo, useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Button, message } from 'antd';
import { useRequest } from 'ahooks';
import { RootState } from '@/models';
import { ConBrandDetailsWebController } from '@/services/swagger/ConBrandDetailsWebController';
import SubscribeBrandModalContent from '../SubscribeBrandModalContent';
import styles from './index.module.scss';

export type BrandSubscriptionButtonProps = {
  /** 品牌id */
  brandId?: string;
  /** 是否已订阅 */
  subscribed?: boolean;
  /** 按钮自定义样式类名 */
  className?: string | undefined;
  /** 按钮自定义样式 */
  style?: CSSProperties | undefined;
  /** 订阅状态改变回调 */
  onChange?: (value: boolean) => void;
  /** 邮箱留资成功回调 */
  onSubmitEmailSuccess?: () => void;
};
const controller = new ConBrandDetailsWebController();

const BrandSubscriptionButton: React.FC<BrandSubscriptionButtonProps> = ({
  brandId,
  subscribed,
  className,
  style,
  onChange,
  onSubmitEmailSuccess,
}) => {
  const { token, memberInfo } = useSelector((state: RootState) => state.user);
  const { totalCanSubNum, alreadySubNum, canSubBalanceNum, hasMember, email } = memberInfo;
  const { run } = useRequest(
    async () => {
      const res = await controller.conBrandDetailsWebControllerV1SubBrandUsingPut1({
        conBrandId: brandId,
        operFlag: !subscribed,
      });
      return res.data;
      ``;
    },
    {
      manual: true,
      onSuccess(res) {
        if (res.code !== 200) {
          message.error(res.msg);
          return;
        }
        onChange?.(!subscribed);
        message.success(res.msg);
      },
    }
  );
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    if (!token) {
      dispatch({ type: 'modal/openUserLoginModal', payload: 'login' });
    } else if ((!subscribed && canSubBalanceNum <= 0) || !email) {
      /**
       * 未留资直接弹框留资
       * 剩余订阅次数（可订阅次数为0）时：
       * 若用户已留资，则触发引导开通/升级会员弹窗
       * 若用户未留资且非会员，则触发普通留资弹窗
       * 若用户未留资且是会员，则触发订阅数已满的留资弹窗
       *  */
      dispatch({
        type: 'modal/open',
        payload: {
          content: (
            <SubscribeBrandModalContent
              type={email ? 'error' : hasMember && canSubBalanceNum <= 0 ? 'warning' : 'default'}
              onSubmitEmailSuccess={onSubmitEmailSuccess}
            />
          ),
        },
      });
    } else {
      run();
    }
  }, [canSubBalanceNum, dispatch, email, hasMember, onSubmitEmailSuccess, run, subscribed, token]);

  return (
    <Button
      className={classNames(subscribed ? styles.unsubscribed : styles.subscribed, className)}
      style={style}
      type={subscribed ? 'default' : 'primary'}
      onClick={onClick}
    >
      {subscribed ? '取消订阅' : '+ 订阅'}{' '}
      {!subscribed && !!alreadySubNum && !!totalCanSubNum && `(${alreadySubNum}/${totalCanSubNum})`}
    </Button>
  );
};

export default memo(BrandSubscriptionButton);
